import { useMutation } from "@tanstack/react-query";
import SignUpFlowValues from "../../../models/formModels/signUpFlowValues.model";
import axiosInstance from "../../../api";
import { useHistory } from "react-router-dom";
import toastMessages from "../../helpers/toastMessage";
import PhysicianSignUpValues from "../../../models/formModels/physicianSignUpValues.model";

function useSignUpUser() {
  const history = useHistory();
  return useMutation({
    mutationKey: ["signUpUser"],
    retry:false,
    mutationFn: (data: SignUpFlowValues) => {
      let apiData: any = {
        org: {
          ...data.org,
        },
        user: {
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          email: data.user.email,
          roles: ["Office Manager"],
        },
      };

      if (data.role === "Both" || data.role === "Physician") {
        apiData = {
          ...apiData,
          user: {
            ...apiData.user,
            suffix: (data.user as PhysicianSignUpValues).suffix,
            specialty: (data.user as PhysicianSignUpValues).specialty,
            npi: (data.user as PhysicianSignUpValues).npi,
            roles:
              data.role === "Both"
                ? ["Office Manager", "Physician"]
                : ["Physician"],
          },
        };
      }

      return axiosInstance.post("v1/auth/new-flow/register", apiData);
    },
    onError: (error: any) => {
      const { data: errorData } = error?.response;
      const message = errorData ? errorData.message : !!error;
      toastMessages.error(message);
    },
    onSuccess: (result: any) => {
      const { message, error, status } = result;
      toastMessages.success(
        message ?? "Organization and user has been created"
      );
      history.push("/verify-email");
    },
  });
}
export default useSignUpUser;
